import { render, staticRenderFns } from "./LivewireFileProgress.vue?vue&type=template&id=2dc12888&"
import script from "./LivewireFileProgress.vue?vue&type=script&lang=js&"
export * from "./LivewireFileProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports